export const STORE_KEY = '@@store'
export const GET_ALL_STORES_REQUEST = `${STORE_KEY}/GET_ALL_STORES_REQUEST`
export const GET_ALL_STORES_SUCCESS = `${STORE_KEY}/GET_ALL_STORES_SUCCESS`
export const GET_ALL_STORES_FAILURE = `${STORE_KEY}/GET_ALL_STORES_FAILURE`
export const GET_STORE_INFORMATION_REQUEST = `${STORE_KEY}/GET_STORE_INFORMATION_REQUEST`
export const GET_STORE_INFORMATION_SUCCESS = `${STORE_KEY}/GET_STORE_INFORMATION_SUCCESS`
export const GET_STORE_INFORMATION_FAILURE = `${STORE_KEY}/GET_STORE_INFORMATION_FAILURE`
